import { validateUrl } from "./utils";
import { createPopToken } from "../popToken/createPop";
import axios from 'axios';

export const axiosToken = async ({
    method,
    url,
    data
  }) => {
    if (!url || typeof url !== 'string') {
      throw new Error('Invalid URL: URL must be a non-empty string');
    }
  
    // Validate the URL to prevent SSRF attacks
    const isValidUrl = validateUrl(url);
    if (!isValidUrl) {
      throw new Error('Invalid URL: SSRF protection - URL not allowed');
    }
  
    const pop_token = createPopToken(method, url, null, data);
  
    const headers = {
      'X-Authorization': pop_token
    };
  
    return axios({
      method,
      url,
      data,
      headers,
    });
  };

